<template>
  <div class="wf-hero-banner-with-cta mt-3 my-project-cover">
    <picture v-if="projectDetails.boardDetails.coverPhoto">
      <img
        :src="projectDetails.boardDetails.coverPhoto"
        :alt="projectDetails.boardDetails.title || ''"
        class="responsive-image background-image"
      />
    </picture>
    <div class="container-fluid">
      <div class="wf-hero-banner-with-cta-content">
        <h5>
          {{ projectDetails.boardDetails.title }}
        </h5>
        <p>
          {{ projectDetails.boardDetails.description }}
        </p>
        <p></p>
        <div class="wf-hero-banner-with-cta-buttons" v-if="userRole">
          <button class="btn btn-primary" @click="editProject">{{ $resourceString["myProject.Project.EditPage.Title"] }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default{
  props: ["projectDetails", "userRole"],
  methods: {
    editProject(){
      this.$emit("editProject");
    },
  }
}

</script>
